import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import validator from 'validator'
import XMLParser from "../../utilities/XMLParser";
import Utils from "../../utilities/Utils";
import { OntarioColumn, OntarioRow } from "../../theme";
import { CheckboxComponent } from "./CheckboxComponent";
import { TextComponent } from "./TextComponent";
import { PhoneComponent } from "./PhoneComponent";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { RichTextComponent } from "./RichTextComponent";
import { ButtonComponent } from "./ButtonComponent";

interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
  callbackStepIndex?: (index: number, returnIndex?: number) => void;
}

interface State {


}
export class RowComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

    this.props.field.Touched = false;
    let field = this.props.field;
    FormValidationUtils.runJavascript(field);
  }


  onTextEditChange = (e) => {
    let field = this.props.field;
    let elem = e.originalEvent ? e.originalEvent.target : e.target;
    let val = elem.value;
    field.Value = val;

    FormValidationUtils.validateText(field);

    FormValidationUtils.runJavascript(field);

    this.props.callbackElement(this.props.field.parent.parent.parent);
  }

  onCheckboxChange = (e) => {
    const val = (e.target.checked) ? 'Y' : 'N';

    // let control = this.props.field;
    let field = this.props.field;
    this.props.field.Value = val;

    FormValidationUtils.validateCheckbox(field);

    FormValidationUtils.runJavascript(field);
    this.props.callbackElement(this.props.field.parent.parent.parent);
  }

  render() {
    let field = this.props.field;
    if (!field.Visible) return null;
    let editable = this.props.editable;
    const requireLabel = this.props.isEng ? "(required)" : "(obligatoire)";
    let requiredField = this.props.requiredField;
    let controlArray = [];

    let fieldHtml = [];

    let HtmlToReactParser = require('html-to-react').Parser;
    const htmlToReactParser = new HtmlToReactParser();
    const reactElement = field.MessageBody != null ? htmlToReactParser.parse(this.props.isEng ? field.MessageBody : field.MessageBodyFRA) : null;
    let hintHtml = this.props.isEng ? field.Hint : field.HintFR;
    let hint;
    if (field.Hint) {
      hint = htmlToReactParser.parse(hintHtml);
    }

    if (editable) {
      if (field.subSectionList !== undefined && field.subSectionList != null && field.subSectionList.length > 0) {
        field.subSectionList[0].ListOfFormSectionElements.forEach(p => {
          const title = this.props.isEng ? p.ENUTitle : p.FRATitle;

          let labelControlArray = (
            <label htmlFor={p.LoadBindName} className="ontario-label" >
              {title}<span className="ontario-label__flag"><span className='ontario-label__flag'>{this.props.isEng? p.Optional=="N"? "(required)": "(optional)": p.Optional=="N"? "(obligatoire)": "(facultatif)"}</span>
              </span>
              {p.TooltipENU && (<i role='tooltip' title={p.TooltipENU} className="pi pi-info-circle"></i>)}
            </label>
          )

          switch (p.Datatype) {
            case "Checkbox":
              fieldHtml.push(<div>
                <CheckboxComponent key={"CheckboxComponent_" + p.Id + "_" + field.Id} field={p} editable={editable}
                  title={p.ENUTitle} labelControlArray={labelControlArray} requiredField={p.Optional == "N"} usedForFilter={null} hint={p.hintExpansionTitle}
                  isEng={this.props.isEng}
                  callbackElement={() => { this.props.callbackElement(this.props.field.parent.parent.parent) }}>
                </CheckboxComponent> </div>);
              break;
            case "Label":
              fieldHtml.push(<RichTextComponent key={"RichTextComponent_" + p.Id + "_" + field.Id} field={p} editable={editable}
                title={p.ENUTitle} labelControlArray={labelControlArray} requiredField={p.Optional == "N"}
                isEng={this.props.isEng}
                callbackElement={() => { this.props.callbackElement(this.props.field.parent.parent.parent) }}>
              </RichTextComponent>);
              break;
            case "Text":
              fieldHtml.push(<div style={{ marginRight: '11px' }}>
                <TextComponent key={"TextComponent_" + "_" + p.Id} field={p} editable={editable}
                  title={p.enuToolTip} labelControlArray={labelControlArray} requiredField={p.Optional == "N"}
                  isEng={this.props.isEng} 
                  callbackElement={() => { this.props.callbackElement(this.props.field.parent.parent.parent) }}>
                </TextComponent></div>);
              break;
            case "PhoneNumber":
              fieldHtml.push(<PhoneComponent key={"PhoneComponent_" + "_" + p.Id + "_" + field.Id} field={p} editable={editable}
                title={p.enuToolTip} labelControlArray={labelControlArray} requiredField={p.Optional == "N"}
                isEng={this.props.isEng}
                callbackElement={() => { this.props.callbackElement(this.props.field.parent.parent.parent) }}>
              </PhoneComponent>);
              break;
            case "Button":
              fieldHtml.push(<ButtonComponent key={"ButtonComponent" + p.Id}
                field={p}
                editable={editable}
                title={p.enuToolTip}
                labelControlArray={labelControlArray}
                requiredField={requiredField}
                isEng={this.props.isEng}
                callback={(programContainer) => { this.props.callbackElement(programContainer) }}
                callbackStepIndex={(stepperIndex) => this.props.callbackStepIndex(stepperIndex)}>

              </ButtonComponent>);
              break;
          }
        })
      }
    }

    return <div style={{ display: 'flex', width: '100%', gap: `${field.Gap}px` }}>
      {fieldHtml}

    </div>;
  }

}